<template>
  <div class="logo">
        <div class="logo_img_box1">
               <img
         v-show="NavBar == 1"
        style="height:42px"
        src="../../../../assets/image/Logo/logo2.png"
        alt
      />
           <img
         v-show="NavBar == 2"
        style="height:42px"
        src="../../../../assets/image/Logo/logo.png"
        alt
      />

        </div>
    <!-- <div class="logo_img_box1">

      <img
        v-show="NavBar == 1"
        class="home_logo_img1"
        src="../../../../assets/image/Logo/home_side_bar.png"
        alt
      />
      <img
        v-show="NavBar == 2"
        class="home_logo_img1"
        src="../../../../assets/image/Logo/logo1.png"
        alt
      />
    </div> -->

    <div class="logo_img_box2">
      <img
        class="home_logo_img1"
        src="../../../../assets/image/Logo/home_side_bar_sdg.png"
        alt
      />
    </div>
    <div
      class="gradient"
      :class="[NavBar == 1 ? 'NavBarColor1' : 'NavBarColor2']"
    ></div>

    <div class="system_name" :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']">
      <div :class="[NavBar == 1 ? 'fontColor1' : 'fontColor2']">
        {{ $t("Nav.Name") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
    mixins: [mapMixin],
  props: ["NavBar"],
};
</script>

<style lang="scss" scoped>
  .zhFamilytitle{
    font-family: $zhFamily;
    // margin-top: 12px;
  }
  .enfamilytitle{
 font-family: $enfamilytitle;

  }
.logo {
  display: flex;
  height: 35px;
  flex-direction: row;
  // align-items: center;
  .logo_img_box1 {
    // width: 110px;
    height: 42px;
    margin-right: 12px;
    img {
      // width: 100%;
      height: 100%;
    }
  }
  .logo_img_box2 {
    // width: 60px;
    height: 42px;
    margin-right: 10px;
    img {
      // width: 100%;
        height: 100%;
    }
  }
  .NavBarColor1 {
    background: linear-gradient(
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0.1)
    );
  }
  .NavBarColor2 {
    background: linear-gradient(
      rgba(255, 255, 255, 0.1),
      rgba(10, 151, 217, 1),
      rgba(255, 255, 255, 0.1)
    );
  }
  .gradient {
    margin-right: 11px;
    height: 40px;
    width: 2px;
  }

  .system_name {
    // width: 220px;
    // height: 24px;
    // line-height: 20px;
    // margin-top: 8px;
    font-size: 20px;
    display: flex;
    align-items: center;
    font-family: "Arial, sans-serif";
    font-weight: 600;
    letter-spacing: 1px;
    // white-space: nowrap;
    // width: 410px;
  }
  .fontColor1 {
    color: #fff !important;
    font-size: 20px;
  }
  .fontColor2 {
    color: #0052d9 !important;
    font-size: 20px;
  }
}
</style>